module.exports = __webpack_public_path__ + "img/tranquil_boots_active.1d3fcab1.png";